import memoize from 'transmute/memoize';
import uniqueIdForObject from 'automation-ui-core/utils/uniqueIdForObject';
import { calculateReverseAdjacencyMap } from 'automation-ui-directed-graph/DirectedNodes';
export const calculateNodeWidthMultipliers = memoize(edges => {
  const {
    reverseAdjacencyMap,
    leafEdgesToNodes
  } = calculateReverseAdjacencyMap(edges);
  const nodeWidths = {};
  let nodesToVisit = [...leafEdgesToNodes];
  while (nodesToVisit.length > 0) {
    const nodeId = nodesToVisit.pop().getFromNode();
    nodeWidths[nodeId] = (nodeWidths[nodeId] || 0) + 1;
    const nextStartingNodes = reverseAdjacencyMap.get(nodeId) || [];
    nodesToVisit = nodesToVisit.concat(nextStartingNodes);
  }
  return nodeWidths;
}, edges => `${uniqueIdForObject(edges)}`);